<template>
  <div class="yzm-title flex flex-item-center" :style="{ ...marginStyle }">
    <div class="yzm-title__border" :style="{ ...borderStyle }" v-if="item.setting.leftBlueBarIsShow"></div>
    <div class="flex-1" :style="{ ...textStyle }">{{ item.setting.text }}</div>
  </div>
</template>
<script setup>
import { defineProps, computed, onMounted, defineEmits } from 'vue'
import { defaultProps } from './defaultProps'
const props = defineProps({
  ...defaultProps
})
const marginStyle = computed(() => {
  let item = props.item.setting
  return {
    marginTop: `${item.marginTop}px`,
    marginBottom: `${item.marginBottom}px`,
    marginLeft: `${item.marginLeft}px`,
    marginRight: `${item.marginRight}px`
  }
})
const textStyle = computed(() => {
  let item = props.item.setting
  return {
    fontSize: `${item.fontSize}px`,
    color: item.color,
    textAlign: item.textAlign,
    fontWeight: item.fontWeight,
    fontStyle: item.fontStyle
  }
})
const borderStyle = computed(() => {
  let item = props.item.setting
  return {
    height: `${item.fontSize}px`,
    background: item.color
  }
})
const emit = defineEmits(['childMounted'])
onMounted(() => {
  emit('childMounted')
})
</script>
<style lang="less" scoped>
.yzm-title {
  &__border {
    width: 3px;
    margin-right: 6px;
  }
}
</style>
